import React from 'react';
import { TextInput } from '@/components/design-system/atoms/text/text-input';

interface FormFieldProps {
  label: string;
  name: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
  type?: string;
  error?: string;
  className?: string;
  showHelpText?: boolean;
  helpText?: string;
  prefix?: string;
}

export const FormField: React.FC<FormFieldProps> = ({
  label,
  name,
  value,
  onChange,
  placeholder,
  type = 'text',
  error,
  className = '',
  showHelpText = false,
  helpText,
  prefix,
}) => {
  return (
    <div className={className}>
      <label className="mb-1 block text-[12px] font-medium text-N900">{label}</label>
      <div className="relative">
        {prefix && (
          <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
            <span className="text-[12px] text-text-primaryLight">{prefix}</span>
          </div>
        )}
        <TextInput
          name={name}
          type={type}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          className={`w-full`}
          label={label}
          showLabel={false}
          invalid={!!error}
          errorMessage={error}
          showErrorMessage={!!error}
          helpMessage={showHelpText ? helpText : undefined}
        />
      </div>
    </div>
  );
};
